export const prepBlurhashUrl = (url: string, hash?: string) => {
  const urlObj = new URL(url, window.location.origin);
  if (hash) urlObj.searchParams.set("b", encodeURIComponent(hash));
  return urlObj.toString();
};
